import { useParams } from "react-router-dom";

import { getBreadcrumbsBackUrl } from "components/Breadcrumbs/helpers";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";

import { FILTERS_ORDER_SETTINGS_KEY } from "../../TemplatesWorkbench/constants";
import useTemplate from "../../Template/useTemplate";
import PageLayout from "./PageLayout";

const TemplatesMarketplaceTemplate = () => {
  const { templateId } = useParams<{ templateId: string }>();

  const { error, loading, data } = useTemplate(templateId);

  useBreadcrumbs(
    [
      {
        title: "Templates",
        link: getBreadcrumbsBackUrl("/templates", FILTERS_ORDER_SETTINGS_KEY),
      },
      {
        title: data?.blueprintVersionedGroup?.name || "",
      },
    ],
    [data?.blueprintVersionedGroup?.name]
  );

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && !data?.blueprintVersionedGroup) {
    return <PageLoading />;
  }

  if (!data?.blueprintVersionedGroup) {
    return <NotFoundPage />;
  }

  const template = data.blueprintVersionedGroup;

  return <PageLayout template={template} />;
};

export default TemplatesMarketplaceTemplate;
